import { render, staticRenderFns } from "./productPrinterProofTable.vue?vue&type=template&id=57f2544b&"
import script from "./productPrinterProofTable.vue?vue&type=script&lang=js&"
export * from "./productPrinterProofTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports